'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./timeline.scss');

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Timeline(_ref) {
  var activeStep = _ref.activeStep,
      className = _ref.className,
      onChange = _ref.onChange,
      steps = _ref.steps;

  var classes = (0, _classnames2.default)('timeline', className);

  var items = steps.map(function (step, i) {
    var stepNumber = i + 1;
    var isActive = stepNumber <= activeStep;
    var itemsClasses = (0, _classnames2.default)('timeline__item', isActive && 'timeline__item--active', stepNumber === activeStep && 'timeline__item--bold', stepNumber > steps.length && 'timeline__item--bold');

    return _react2.default.createElement(
      'li',
      { className: itemsClasses, key: i, onClick: isActive ? function () {
          return onChange(stepNumber);
        } : null },
      _react2.default.createElement(
        'div',
        { className: 'timeline__top-row' },
        stepNumber < activeStep ? _react2.default.createElement(
          'span',
          { className: 'timeline__step' },
          _react2.default.createElement(_icon2.default, { name: 'check', size: '12' })
        ) : _react2.default.createElement(
          'span',
          { className: 'timeline__step' },
          stepNumber
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'timeline__bottom-row' },
        _react2.default.createElement(
          'span',
          { className: 'timeline__text' },
          steps[i]
        )
      )
    );
  });

  return _react2.default.createElement(
    'ul',
    { className: classes },
    items
  );
}

Timeline.propTypes = {
  activeStep: _propTypes2.default.number,
  className: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  steps: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

Timeline.defaultProps = {
  onChange: function onChange() {
    return undefined;
  }
};

exports.default = Timeline;